import React, { useRef, useState, useLayoutEffect, Fragment } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.styl';

export default function ShowMore({ more, less, children, minHeight }) {
  const contentRef = useRef();
  const [open, setOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState(minHeight);

  useLayoutEffect(() => {
    if (contentRef.current) setMaxHeight(contentRef.current.offsetHeight);
  }, [children, contentRef]);

  const safeHeight = maxHeight > minHeight ? minHeight : 'auto';

  return (
    <Fragment>
      <div
        ref={contentRef}
        className={styles.content}
        style={{ height: open ? 'auto' : safeHeight }}
      >
        {children}
      </div>

      {maxHeight > minHeight && (
        <button
          type="button"
          className={styles.button}
          onClick={() => setOpen(!open)}
        >
          {open ? less : more}
        </button>
      )}
    </Fragment>
  );
}

ShowMore.propTypes = {
  more: PropTypes.string,
  less: PropTypes.string,
  children: PropTypes.node,
  minHeight: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/common/ShowMore/index.js